/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CloneProjectVideoEditorProjectsMutationRequest, CloneProjectVideoEditorProjectsMutationResponse, CloneProjectVideoEditorProjectsPathParams } from "../models/CloneProjectVideoEditorProjects";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { cloneProjectVideoEditorProjects } from "../axios/cloneProjectVideoEditorProjects";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const cloneProjectVideoEditorProjectsMutationKey = () => ["web-app-bff-api", { url: '/video-editor/projects/:id/clone' }] as const

export type CloneProjectVideoEditorProjectsMutationKey = ReturnType<typeof cloneProjectVideoEditorProjectsMutationKey>

export function cloneProjectVideoEditorProjectsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CloneProjectVideoEditorProjectsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = cloneProjectVideoEditorProjectsMutationKey()
        return mutationOptions<CloneProjectVideoEditorProjectsMutationResponse, ResponseErrorConfig<Error>, {id: CloneProjectVideoEditorProjectsPathParams["id"], data: CloneProjectVideoEditorProjectsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return cloneProjectVideoEditorProjects(id, data, config)
          },
        })

}

/**
 * @summary Clone a project (requires new name); response includes creator and published platforms
 * {@link /video-editor/projects/:id/clone}
 */
export function useCloneProjectVideoEditorProjects<TContext>(options: 
{
  mutation?: UseMutationOptions<CloneProjectVideoEditorProjectsMutationResponse, ResponseErrorConfig<Error>, {id: CloneProjectVideoEditorProjectsPathParams["id"], data: CloneProjectVideoEditorProjectsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CloneProjectVideoEditorProjectsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? cloneProjectVideoEditorProjectsMutationKey()

          const baseOptions = cloneProjectVideoEditorProjectsMutationOptions(config) as UseMutationOptions<CloneProjectVideoEditorProjectsMutationResponse, ResponseErrorConfig<Error>, {id: CloneProjectVideoEditorProjectsPathParams["id"], data: CloneProjectVideoEditorProjectsMutationRequest}, TContext>
          

          return useMutation<CloneProjectVideoEditorProjectsMutationResponse, ResponseErrorConfig<Error>, {id: CloneProjectVideoEditorProjectsPathParams["id"], data: CloneProjectVideoEditorProjectsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CloneProjectVideoEditorProjectsMutationResponse, ResponseErrorConfig<Error>, {id: CloneProjectVideoEditorProjectsPathParams["id"], data: CloneProjectVideoEditorProjectsMutationRequest}, TContext>
      
}